import { updateObject } from 'utils/updateObject'
import { List, Map } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'

const initialState = {
  loading: true,
  loadFailed: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setClientsList = (state, { payload: { data, pagination } }) =>
  updateObject(state, {
    ...state,
    loadFailed: false,
    loading: false,
    data: data.map((client) => ({ ...client, subRows: client.subRows ?? [] })),
    pagination: {
      ...state.pagination,
      ...pagination,
    },
  })

const loadFailed = (state) =>
  updateObject(state, { loadFailed: true, loading: false, data: [] })

const loadCanceled = (state) =>
  updateObject(state, { loadFailed: false, loading: true, data: [] })

const listRemoveItem = (state, { payload }) =>
  updateObject(state, {
    data: state.data.filter((client) => client.id !== payload.id),
  })

const clientUpdate = (state, { payload }) => {
  const clients = List(state.data)
  const index = clients.findIndex((client) => client.id === payload.id)
  const updatedClients = clients.update(index, (client) =>
    Map(client).merge(payload.update),
  )
  return updateObject(state, { data: updatedClients.toJS() })
}

const clientsSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const dropData = (state) =>
  updateObject(state, {
    data: [],
    loading: true,
    loadFailed: false,
    pagination: { offset: 0, limit: 50, total: 0 },
  })

const toggleLoading = (state, { payload }) =>
  updateObject(state, { loading: payload.loading })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENCY/CLIENTS_SET_DATA':
      return setClientsList(state, action)
    case 'AGENCY/CLIENTS_SET_FILTER':
      return clientsSetFilter(state, action)
    case 'AGENCY/CLIENTS_FETCH_FAILED':
      return loadFailed(state, action)
    case 'AGENCY/CLIENTS_FETCH_CANCELED':
      return loadCanceled(state, action)
    case 'AGENCY/CLIENTS_LIST_REMOVE_ITEM':
      return listRemoveItem(state, action)
    case 'AGENCY/CLIENT_UPDATE':
      return clientUpdate(state, action)
    case 'AGENCY/CLIENTS_DROP_DATA':
      return dropData(state)
    case 'AGENCY/CLIENTS_TOGGLE_LOADING':
      return toggleLoading(state, action)
    default:
      return state
  }
}

export default reducer
